import { Button, EmailField, FormFeedback } from '@sparemin/blockhead';
import React from 'react';
import AuthSpacer from '../AuthSpacer';
import useForgotPasswordRequestForm, {
  UseForgotPasswordRequestFormOptions,
} from './useForgotPasswordRequestForm';

export interface ForgotPasswordRequestFormProps
  extends Pick<
    UseForgotPasswordRequestFormOptions,
    'onError' | 'onSubmit' | 'onSuccess'
  > {}

/**
 * A form that a user submits in order to get a reset-password link from the API
 */
export const ForgotPasswordRequestForm: React.FC<
  ForgotPasswordRequestFormProps
> = ({ onError, onSubmit, onSuccess }) => {
  const {
    hasInputError,
    isLoading,
    onSubmit: handleSubmit,
    register,
    formState: { errors },
    validationState,
  } = useForgotPasswordRequestForm({ onError, onSubmit, onSuccess });

  return (
    <AuthSpacer as="form" onSubmit={handleSubmit}>
      <EmailField
        aria-label="email field"
        autoComplete="email"
        errorMessage={errors.email?.message}
        fluid
        isDisabled={isLoading}
        placeholder="Email"
        validationState={validationState.email}
        {...register('email')}
      />
      {errors.unregisteredError && (
        <FormFeedback>{errors.unregisteredError.message}</FormFeedback>
      )}
      <Button isDisabled={hasInputError || isLoading} fluid type="submit">
        submit
      </Button>
    </AuthSpacer>
  );
};

export default ForgotPasswordRequestForm;
